module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C243"
  }, [_c('em', [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_vm._v("Author’s Note on Names")])])]), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_c('p', {
    staticClass: "P25"
  }, [_vm._v("There are many Huxleys in this book. To distinguish between the two on whom I focus most closely, Thomas Henry Huxley and Julian Huxley, I use ‘Huxley’ for the grandfather and ‘Julian’ for the grandson.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ab2ac620","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/06_Author_s_Note_on_Names.vue
// module id = 72
// module chunks = 0